module.exports = __webpack_public_path__ + "static/media/tripsavvi.fff3c1f5.png";